import React, { useContext } from 'react'
import { LoanCalculatorContext } from 'modules/react/loan-calculator/LoanCalculatorContainer'

export default function CarHeaderWithText() {
  const { carInfo: { name, tagline, text } } = useContext(LoanCalculatorContext)

  return (
    <div className='lc-car-header lc-car-header--with-text'>
      <div className='lc-car-header__left'>
        <h2 className='lc-car-header__name'>{name}</h2>
        <span className='lc-car-header__name-tagline'>{tagline}</span>
      </div>
      {text && (
        <>
          <div className='lc-car-header__separator'/>
          <div className='lc-car-header__right'>
            <p className='lc-car-header__text'>{text}</p>
          </div>
        </>
      )}
    </div>
  )
}
